import { render, staticRenderFns } from "./PayBox.vue?vue&type=template&id=4fda77c4&scoped=true&"
import script from "./PayBox.vue?vue&type=script&lang=js&"
export * from "./PayBox.vue?vue&type=script&lang=js&"
import style0 from "./PayBox.vue?vue&type=style&index=0&id=4fda77c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fda77c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fda77c4')) {
      api.createRecord('4fda77c4', component.options)
    } else {
      api.reload('4fda77c4', component.options)
    }
    module.hot.accept("./PayBox.vue?vue&type=template&id=4fda77c4&scoped=true&", function () {
      api.rerender('4fda77c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box/PayBox.vue"
export default component.exports